import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { toast } from "react-toastify";
import Axios from "../axios";
import { useLocation } from "react-router-dom";
import Switch from "@mui/material/Switch";
import moment from "moment";
const RateList = () => {
  const location = useLocation();
  const [allTrip, setAllTrip] = useState();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const { passedValue } = location?.state || {};

  useEffect(() => {
    if (passedValue) {
      fetchAllTrip(0, "", passedValue);
    } else {
      fetchAllTrip(0, "", "");
    }
  }, [passedValue]);

  const fetchAllTrip = (page, search, id) => {
    let data = {
      page: page,
      searchChar: search,
      userID: id,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-trip", data)
      .then((resp) => {
        setAllTrip(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    viewColumns: false,
    serverSide: true,
    rowsPerPageOptions: [],
    count: count,
    page,
    download: false,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchAllTrip(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      fetchAllTrip(page, searchText);
      setSearch(searchText);
    },
  };

  const columns = [
    {
      name: "Action",
      label: "Trip Image",

      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <img
                src={allTrip[dataIndex]?.locationImg}
                style={{ width: "60px" }}
              />
            </>
          );
        },
      },
    },
    {
      name: "tripName",
      label: "Trip Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "mail",
      label: "User Name",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return <div>{allTrip[dataIndex]?.userId?.name}</div>;
        },
      },
    },
    {
      name: "role",
      label: "Created Date",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              {moment(allTrip[dataIndex].createdAt).format("YYYY-MM-DD")}
            </div>
          );
        },
      },
    },

    {
      name: "feature trip",
      label: "Feature Trip",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Switch
                checked={allTrip[dataIndex]?.featureTrip}
                onChange={(event) =>
                  handleChangeExplore(event, allTrip[dataIndex]?._id, "feature")
                }
                inputProps={{ "aria-label": "controlled" }}
              />
            </>
          );
        },
      },
    },
    {
      name: "Explore Trip",
      label: "Explore Trip",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Switch
                checked={allTrip[dataIndex]?.explore}
                onChange={(event) =>
                  handleChangeExplore(event, allTrip[dataIndex]?._id, "explore")
                }
                inputProps={{ "aria-label": "controlled" }}
              />
            </>
          );
        },
      },
    },
  ];

  const handleChangeExplore = (event, tripId, type) => {
    handleStatus(tripId, type); // Pass the checked state and tripId
  };
  const handleStatus = (id, type) => {
    let api;
    let data = {
      id: id,
      userID: passedValue ? passedValue : "",
    };
    if (type === "explore") {
      api = "update-explore-trips";
    } else {
      api = "update-feature-trip";
    }
    Axios.post(process.env.REACT_APP_BACKEND + api, data)
      .then((resp) => {
        setAllTrip(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
        toast.success(resp && resp.data && resp.data.message);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  return (
    <>
      <MUIDataTable
        title={"Rate Type List"}
        data={allTrip}
        columns={columns}
        options={options}
      />
    </>
  );
};
export default RateList;
